var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.componentClasses,on:{"click":function($event){return _vm.clicked()}}},[_c('svg',{attrs:{"width":"12","height":"3","viewBox":"0 0 12 3","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"12","height":"3","rx":"1.5","fill":"white"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }